import { createFileRoute, Link } from "@tanstack/react-router";
import { Layout } from "@/components/Layout";

export const Route = createFileRoute("/kayttoehdot")({
  head: () => ({
    meta: [
      { title: "Käyttöehdot — Montessori24" },
      { name: "description", content: "Montessori24-verkkokaupan yleiset sopimus- ja käyttöehdot kuluttajakaupassa." },
      { property: "og:title", content: "Käyttöehdot — Montessori24" },
      { property: "og:description", content: "Verkkokaupan sopimusehdot." },
      { property: "og:url", content: "https://montessori24.fi/kayttoehdot" },
    ],
    links: [{ rel: "canonical", href: "https://montessori24.fi/kayttoehdot" }],
  }),
  component: Terms,
});

function Terms() {
  return (
    <Layout>
      <section className="container-prose pt-16 pb-24 md:pt-24">
        <span className="text-xs uppercase tracking-[0.25em] text-muted-foreground">Lakisääteinen</span>
        <h1 className="mt-3 text-5xl text-foreground md:text-6xl text-balance">Käyttöehdot</h1>
        <p className="mt-6 max-w-2xl text-muted-foreground">
          Päivitetty 21.5.2026. Näitä ehtoja sovelletaan Montessori24-verkkokaupan (MLR Solutions OY, Y-tunnus 3582909-7)
          ja asiakkaan välisissä kauppasopimuksissa. Sovellamme kuluttajansuojalakia ja kuluttaja-asiamiehen ohjeita.
        </p>

        <div className="mt-12 space-y-10 max-w-2xl text-sm leading-relaxed text-muted-foreground">
          <div>
            <h2 className="text-foreground text-lg">1. Myyjä</h2>
            <p className="mt-2">
              MLR Solutions OY, Y-tunnus 3582909-7, Helsinki. Yhteydenotot:{" "}
              <a className="underline" href="mailto:asiakaspalvelu@montessori24.fi">asiakaspalvelu@montessori24.fi</a>.
            </p>
          </div>

          <div>
            <h2 className="text-foreground text-lg">2. Hinnat ja maksaminen</h2>
            <p className="mt-2">
              Tuotteiden hinnat ilmoitetaan euroissa ja sisältävät arvonlisäveron (25,5 %). Pidätämme oikeuden
              hintojen muutoksiin. Maksu tapahtuu tilausvaiheessa valitulla maksutavalla turvallisen maksunvälittäjän kautta.
            </p>
          </div>

          <div>
            <h2 className="text-foreground text-lg">3. Toimitus</h2>
            <p className="mt-2">
              Toimitusehdot ja -ajat on kuvattu erillisessä <Link className="underline" to="/toimitus">toimitussivulla</Link>.
              Toimitus tapahtuu 3–7 arkipäivässä. Toimitus on aina ilmainen kaikkiin Suomen tilauksiin.
            </p>
          </div>

          <div>
            <h2 className="text-foreground text-lg">4. Peruutusoikeus (14 päivää)</h2>
            <p className="mt-2">
              Sinulla on kuluttajansuojalain mukainen 14 päivän peruutusoikeus tuotteen vastaanottamisesta. Tarjoamme
              lisäksi vapaaehtoisen 30 päivän palautusedun, joka ei rajoita lakisääteisiä oikeuksiasi. Ohjeet löytyvät{" "}
              <Link className="underline" to="/palautus">palautussivulta</Link>. Peruutusilmoituksen voi tehdä myös
              vapaamuotoisesti sähköpostitse osoitteeseen asiakaspalvelu@montessori24.fi.
            </p>
            <p className="mt-2">
              Peruuttamisoikeuteen sovelletaan kuluttajansuojalain mukaisia poikkeuksia, esimerkiksi asiakkaan
              toivomusten mukaisesti valmistettuja tai muunneltuja mittatilaustuotteita. Peruuttamisaikana saat
              tutustua tuotteeseen kuten myymälässä; vastaat vain arvonalennuksesta, joka johtuu tätä laajemmasta
              käytöstä.
            </p>
          </div>

          <div>
            <h2 className="text-foreground text-lg">5. Takuu ja virhevastuu</h2>
            <p className="mt-2">
              Vastaamme tuotteiden virheistä kuluttajansuojalain mukaisesti. Jos tuotteessa on virhe, ota yhteyttä
              asiakaspalveluun viivytyksettä. Korvaamme virheelliset tuotteet ilman lisäkuluja.
            </p>
          </div>

          <div>
            <h2 className="text-foreground text-lg">6. Kuluttajaneuvonta ja riidanratkaisu</h2>
            <p className="mt-2">
              Pyrimme ensisijaisesti ratkaisemaan erimielisyydet neuvottelemalla. Jos ratkaisua ei löydy, kuluttaja voi
              olla yhteydessä{" "}
              <a className="underline" href="https://www.kkv.fi/kuluttaja-asiat/kuluttajaneuvonta/" target="_blank" rel="noreferrer">kuluttajaneuvontaan</a>{" "}
              ja saattaa asian tarvittaessa{" "}
              <a className="underline" href="https://www.kuluttajariita.fi/" target="_blank" rel="noreferrer">kuluttajariitalautakunnan</a>{" "}
              käsiteltäväksi.
            </p>
          </div>

          <div>
            <h2 className="text-foreground text-lg">7. Sovellettava laki</h2>
            <p className="mt-2">
              Sopimukseen sovelletaan Suomen lakia.
            </p>
          </div>
        </div>
      </section>
    </Layout>
  );
}
